import { deserializeSermonSeries } from "../../src/entities/SermonSeries";
import { WebClient } from "./server/WebClient";

export interface SaveSeriesRequest {
    id: string; 
    parentId?: string; 
    name: string;
    isStarred: boolean;
}

export const SermonSeriesService = {
    getSeries: (id: string) => WebClient.Get(`api/SermonSeries/GetSermonSeries/${id}`, deserializeSermonSeries),
    save: (seriesToSave: SaveSeriesRequest) => WebClient.Post.Validated(`api/SermonSeries/SaveSermonSeries/`, seriesToSave, deserializeSermonSeries),
    createSermonSeries: (name: string, parentId: string | null) => WebClient.Post.Validated(`api/SermonSeries/CreateSermonSeries`, { name, parentId }, deserializeSermonSeries),
    setStarredSeries: (id: string, isStarred: boolean) => WebClient.Put.Validated(`api/SermonSeries/SetStarredSermonSeries`, {id, isStarred}, deserializeSermonSeries),
    setNameSeries: (id: string, name: string) => WebClient.Put.Validated(`api/SermonSeries/SetNameSermonSeries`, {id, name}, deserializeSermonSeries),
    deleteSermonSeries: (id: string) => WebClient.Delete(`api/SermonSeries/DeleteSermonSeries/${id}`),
    undeleteSermonSeries: (id: string) => WebClient.Put.Validated(`api/SermonSeries/UndeleteSermonSeries/`, {id}, deserializeSermonSeries),
    moveSeries: (id: string, parentId: string | null) => WebClient.Put.Validated(`api/SermonSeries/MoveSermonSeries`, {id, parentId}, deserializeSermonSeries)
}